import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'

interface ErrorBoundaryProps {
  error: Error
  reset: () => void
}

export default function ErrorBoundary({ error, reset }: ErrorBoundaryProps) {
  const { t } = useTranslation('common')

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '50vh',
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <h2 style={{ 
          color: '#dc3545', 
          marginBottom: '1rem',
          fontSize: '24px'
        }}>
          {t('errors.title')}
        </h2>
        
        <p style={{ 
          color: '#666', 
          marginBottom: '2rem',
          lineHeight: '1.5'
        }}>
          {t('errors.message')}
        </p>

        <div style={{ 
          backgroundColor: '#f8f9fa',
          padding: '1rem',
          borderRadius: '4px',
          marginBottom: '2rem',
          fontSize: '14px',
          color: '#666',
          textAlign: 'left',
          fontFamily: 'monospace'
        }}>
          {error.message}
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button
            onClick={reset}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            {t('errors.retry')}
          </button>
          
          <Link
            to="/"
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              textDecoration: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            {t('errors.home')}
          </Link>
        </div>
      </div>
    </div>
  )
}
